import {options} from "dropzone";

export function serializeFormInputsToData(formData: FormData, baseElement: HTMLElement){

    baseElement.querySelectorAll('[name]').forEach(formElement => {

        //usuwamy disabled
        if(formElement.hasAttribute('disabled')){
            return;
        }

        switch (formElement.tagName.toLowerCase()){
            case 'input':
                addInputValue(formData, formElement as HTMLInputElement);
                break;

            case 'textarea':
                addTextareaValue(formData, formElement as HTMLTextAreaElement);
                break;

            case 'select':
                addSelectValue(formData, formElement as HTMLSelectElement);
                break;
        }

    });

}

export default function serializeFormInputs(baseElement: HTMLElement): FormData{

    //default js implementation
    if(baseElement.tagName.toLowerCase() == 'form'){
        return new FormData(baseElement as HTMLFormElement);
    }

    let formData = new FormData();

    baseElement.querySelectorAll('[name]').forEach(formElement => {

        //usuwamy disabled
        if(formElement.hasAttribute('disabled')){
            return;
        }

        switch (formElement.tagName.toLowerCase()){
            case 'input':
                addInputValue(formData, formElement as HTMLInputElement);
                break;

            case 'textarea':
                addTextareaValue(formData, formElement as HTMLTextAreaElement);
                break;

            case 'select':
                addSelectValue(formData, formElement as HTMLSelectElement);
                break;
        }

    });

    return formData;
}

function addSelectValue(formData: FormData, select: HTMLSelectElement){

    if(select.type == 'select-one'){
        formData.append(select.name, select.value);
        return;
    }

    for(let i = 0, len = select.options.length; i < len; i++){
        if(select.options.item(i).selected){
            formData.append(select.name, select.options.item(i).value);
        }
    }

}


function addTextareaValue(formData: FormData, textarea: HTMLTextAreaElement){
    formData.append(textarea.name, textarea.value);
}


function addInputValue(formData: FormData, input: HTMLInputElement){

    switch (input.type){

        case 'text':
        case 'date':
        case 'time':
        case 'email':
        case 'number':
        case 'hidden':
        case 'password':
        case 'button':
        case 'submit':
            formData.append(input.name, input.value);
            break;

        case 'checkbox':
        case 'radio':
            if(input.checked){
                formData.append(input.name, input.value)
            }
            break;
    }

}